import React, { useEffect, useState } from 'react';

import OrderTemplatesEdit from '@components/shared/order_templates/OrderTemplatesEdit';
import { useAdminOrderTemplateService } from '@hooks/admin/useAdminOrderTemplateService';

export default function AdminOrderTemplateNew() {
  const service = useAdminOrderTemplateService();
  // 與 admin Edit.tsx 對齊：自行 fetch 一次 sales channels 後注入。
  // 新增頁原本漏傳 salesChannels，導致「適用通路」永遠 No data。
  const [salesChannels, setSalesChannels] = useState([]);

  useEffect(() => {
    let cancelled = false;
    service.getSalesChannels().then((data) => {
      if (cancelled) return;
      setSalesChannels(data || []);
    }).catch((error) => {
      if (cancelled) return;
      console.error('Failed to fetch admin sales channels', error);
      setSalesChannels([]);
    });
    return () => {
      cancelled = true;
    };
  }, [service]);

  return (
    <OrderTemplatesEdit role="admin" service={service} salesChannels={salesChannels} />
  );
}
